import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import {
    fetchKpowHistory,
    fetchKpowSnapshot,
    type KpowHistory,
    type KpowSnapshot,
} from 'react_pages/AmericanPowerIndex/api/kpowApi';

/**
 * The index endpoint is cached server-side, so 60s polling keeps the UI fresh
 * without stampeding the API.
 */
const REFETCH_INTERVAL_MS = 60_000;

export const kpowKeys = {
    all: ['kpow'] as const,
    snapshot: () => [...kpowKeys.all, 'snapshot'] as const,
    history: () => [...kpowKeys.all, 'history'] as const,
};

export const useKpowSnapshot = (): UseQueryResult<KpowSnapshot> =>
    useQuery({
        queryKey: kpowKeys.snapshot(),
        queryFn: fetchKpowSnapshot,
        refetchInterval: REFETCH_INTERVAL_MS,
        staleTime: 30_000,
    });

export const useKpowHistory = (): UseQueryResult<KpowHistory> =>
    useQuery({
        queryKey: kpowKeys.history(),
        queryFn: fetchKpowHistory,
        refetchInterval: REFETCH_INTERVAL_MS,
        staleTime: 30_000,
    });
